import React from 'react';

export default function Quote() {
  return (
    <div>
      <div id="HomeContainer">
        <h3 className="quote-text">
          Mathematics is not about numbers, equation, computations
          <br />
          or algorithms. It is about understandin. - William paul Thurston
        </h3>
      </div>
    </div>
  );
}
